<script setup lang="ts">
import type { StoryblokRichTextNode } from '@storyblok/vue'
import { StoryblokRichText } from '@storyblok/vue'
import type { StoryblokAsset } from '../../types'

interface Props {
  blok: {
    icon?: StoryblokAsset
    title: StoryblokRichTextNode
    full_width?: boolean
    description?: StoryblokRichTextNode
    image?: StoryblokAsset
    invert?: boolean
  }
}
const props = defineProps<Props>()

const imageOptimized = computed(() => props.blok.image ? optimizeImage(props.blok.image.filename) : undefined)
const iconOptimized = computed(() => props.blok.icon ? optimizeImage(props.blok.icon.filename) : undefined)
</script>

<template>
  <div
    v-editable="blok" col
    class="flex flex-col" :class="{
      'max-w-[450px] lg:max-w-[279px]': !blok.full_width,
    }"
  >
    <div
      class="flex flex-col gap-10" :class="{
        'lg:flex-col-reverse': blok.invert,
      }"
    >
      <div v-if="blok.image?.filename" class="small-feature-image">
        <div class="path-image-left" />
        <img :src="imageOptimized" class="w-auto rounded-6 overflow-hidden">
        <div class="path-image-right" />
      </div>

      <div
        class="flex flex-col gap-7"
      >
        <div class="flex justify-between items-center lg:items-start flex-row-reverse lg:justify-start lg:flex-col gap-5 lg:gap-7">
          <div
            v-if="blok.icon?.filename"
            class="flex align-center"
          >
            <img :src="iconOptimized" class="w-auto min-w-[52px] max-h-[52px]">
          </div>

          <div class="font-circular-bold text-[22.62px] leading-[24.882px] tracking-[-0.905px] font-bold">
            <StoryblokRichText :doc="blok.title" />
          </div>
        </div>

        <div class="text-[16px] font-inter font-medium leading-[28px]" :class="$style.textStyle">
          <StoryblokRichText v-if="blok.description" :doc="blok.description" />
        </div>
      </div>
    </div>
  </div>
</template>

<style module>
.text-style {
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: 'cv01' on, 'cv09' on;
}
</style>
